import { __ } from '@wordpress/i18n';
// @ts-ignore
const { registerPaymentMethod } = window.wc.wcBlocksRegistry;
import { decodeEntities } from '@wordpress/html-entities';
import { PAYMENT_METHOD_NAME } from './contants';
import { Options } from '../../../../../../src/interfaces/WoocommercePaymentBlockSupport';
import './style.scss';

// @ts-ignore
const settings = wc.wcSettings.getSetting( 'dokan_razorpay_data' );
const label = decodeEntities( settings?.title ?? __( 'Razorpay', 'dokan' ) );

const canMakePayment = () => {
    return true;
};

/**
 * Content component
 */
const Content = () => {
    return (
        <div className="razorpay-block-description">
            { decodeEntities(
                settings?.description &&
                    typeof settings?.description === 'string'
                    ? settings?.description
                    : __(
                          'Pay securely by Credit or Debit card or Internet Banking through Razorpay.',
                          'dokan'
                      )
            ) }
        </div>
    );
};

/**
 * Label component
 *
 * @param {*} props Props from payment API.
 */
const Label = ( props ) => {
    const { PaymentMethodLabel } = props.components;
    return <PaymentMethodLabel text={ label } />;
};

const options: Options = {
    name: PAYMENT_METHOD_NAME,
    label: <Label />,
    content: <Content />,
    edit: <Content />,
    canMakePayment,
    ariaLabel: label,
    supports: {},
};

registerPaymentMethod( options );
